module.exports = __webpack_public_path__ + "static/img/bg_primary.e979385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/bg_primary.png
// module id = s/R1
// module chunks = 16